/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	HttpClient
} from '@angular/common/http';
import {
	Inject,
	Injectable
} from '@angular/core';
import {
	IWorkflowActionDefinitionsDto
} from '@api/interfaces/workflow/workflow-action-definitions.dto.interface';
import {
	BaseEntityApiService
} from '@api/services/base/base-entity.api.service';
import {
	AppConstants
} from '@shared/constants/app.constants';
import {
	CacheService
} from '@shared/services/cache.service';

/**
 * A class representing the logic and services of the workflow
 * action definitions controller.
 *
 * @export
 * @class WorkflowActionDefinitionsApiService
 * @extends {BaseEntityApiService<IWorkflowActionDefinitionsDto>}
 */
@Injectable()
export class WorkflowActionDefinitionsApiService
	extends BaseEntityApiService<IWorkflowActionDefinitionsDto>
{
	/**
	 * Creates an instance of a WorkflowActionDefinitionsApiService.
	 *
	 * @param {HttpClient} HttpClient
	 * The injected http client to use in the base api service.
	 * @param {CacheService} cache
	 * The injected cache service to use in the base api service.
	 * @memberof WorkflowActionDefinitionsApiService
	 */
	public constructor(
		@Inject(HttpClient) http: HttpClient,
		@Inject(CacheService) cache: CacheService)
	{
		super();
		this.httpClient = http;
		this.cacheService = cache;
		this.endpoint =
			AppConstants.apiControllers.workflowActionDefinitions;
	}
}